export default __webpack_public_path__ + "static/media/eye-look.5526173f.svg";